import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { FiCheckCircle, FiCircle, FiArrowRight } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { useBrand } from '../context/BrandContext';
import api from '../utils/api';
import { resolvePayoutSetupReady } from '../utils/organizerSetup';
import './OrganizerSetupBanner.css';

function OrganizerSetupBanner() {
  const { user } = useAuth();
  const { brands, currentBrand } = useBrand();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [hasEvents, setHasEvents] = useState(false);
  const [stripeReady, setStripeReady] = useState(false);

  const isOrganizer = user?.role === 'organizer';
  const onAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    const loadStatus = async () => {
      if (!isOrganizer || !onAdmin) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const [eventsRes, payoutReady] = await Promise.all([
          api.get('/events/admin?limit=1'),
          resolvePayoutSetupReady({
            brands,
            currentBrand,
            getAccountStatus: async brandId => {
              const stripeRes = await api.get(`/stripe-connect/account-status/${brandId}`);
              return stripeRes.data.data || {};
            }
          })
        ]);
        setHasEvents((eventsRes.data.data || []).length > 0);
        setStripeReady(payoutReady);
      } catch (error) {
        console.error('Setup banner load error:', error);
      } finally {
        setLoading(false);
      }
    };

    loadStatus();
  }, [isOrganizer, onAdmin, brands, currentBrand]);

  if (!isOrganizer || !onAdmin || loading) return null;

  const hasBrand = brands.length > 0;
  const allDone = hasBrand && stripeReady && hasEvents;

  if (allDone) return null;

  return (
    <div className="organizer-setup-banner">
      <div className="banner-content">
        <div className="banner-title">Finish Setup to Publish Events</div>
        <div className="banner-steps">
          <div className="banner-step">
            {hasBrand ? <FiCheckCircle /> : <FiCircle />}
            <span>Brand</span>
          </div>
          <div className="banner-step">
            {stripeReady ? <FiCheckCircle /> : <FiCircle />}
            <span>Payouts</span>
          </div>
          <div className="banner-step">
            {hasEvents ? <FiCheckCircle /> : <FiCircle />}
            <span>First Event</span>
          </div>
        </div>
      </div>
      <Link to="/admin/welcome" className="btn btn-primary btn-sm">
        Continue Setup <FiArrowRight />
      </Link>
    </div>
  );
}

export default OrganizerSetupBanner;
